<template>
  <div class="zhanwei4"></div>

  <div class="header-action-bar">
    <h1 class="page-title">{{ $t("edit.cover.title") }}</h1>
    <div class="btns">
      <el-button
        size="large"
        type="primary"
        @click="handleSave"
        class="save-top-btn"
      >
        {{ $t("edit.cover.save") }}
      </el-button>
    </div>
  </div>

  <div class="zhanwei4"></div>

  <div class="coverSetting">
    <div class="coverSetting_left">
      <el-form
        :model="form"
        label-width="auto"
        label-position="top"
        class="clean-form"
      >
        <div class="form-row">
          <el-form-item :label="$t('edit.cover.gameTitle')" class="flex-2">
            <el-input
              v-model="form.gameTitle"
              placeholder="请输入游戏标题"
              size="large"
            />
          </el-form-item>
          <el-form-item label="游戏创作者" class="flex-1">
            <el-input
              v-model="form.author"
              placeholder="作者名称"
              size="large"
            />
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item :label="$t('edit.cover.opening_hours')">
            <el-input
              v-model="form.openHour"
              placeholder="例如: 09:00 - 18:00"
              size="large"
            />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.experience_time')">
            <el-input
              v-model="form.experienceTime"
              placeholder="例如: 周二至周日"
              size="large"
            />
          </el-form-item>
        </div>

        <div class="form-row geolocation-row">
          <el-form-item :label="$t('edit.cover.begin')" class="flex-2">
            <el-input
              v-model="form.beginPoint"
              placeholder="起点位置描述"
              size="large"
            />
          </el-form-item>
          <el-form-item label="经度 (Log)" class="flex-1">
            <el-input v-model="form.log" placeholder="经度" size="large" />
          </el-form-item>
          <el-form-item label="纬度 (Lat)" class="flex-1">
            <el-input v-model="form.lat" placeholder="纬度" size="large" />
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item label="精确地点名称" class="flex-1">
            <el-input
              v-model="form.placeName"
              placeholder="具体定位场所名称"
              size="large"
            />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.end')" class="flex-1">
            <el-input
              v-model="form.endPoint"
              placeholder="终点位置描述"
              size="large"
            />
          </el-form-item>
        </div>

        <div class="form-row triple-row">
          <el-form-item :label="$t('edit.cover.walking_distance')">
            <el-input v-model="form.walk" placeholder="公里数" size="large" />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.estimated_time')">
            <el-input
              v-model="form.estimateTime"
              placeholder="预计时间"
              size="large"
            />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.player_age')">
            <el-input
              v-model="form.playerAge"
              placeholder="适用年龄"
              size="large"
            />
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item :label="$t('edit.cover.Facilities_along_way')">
            <el-input
              v-model="form.along"
              placeholder="沿途洗手间、便利店等设施说明"
              size="large"
            />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.transportation')">
            <el-input
              v-model="form.transportation"
              placeholder="推荐交通工具"
              size="large"
            />
          </el-form-item>
        </div>

        <el-form-item :label="$t('edit.cover.address')">
          <el-input
            v-model="form.merchantAddress"
            placeholder="请输入完整详细地址"
            size="large"
          />
        </el-form-item>

        <div class="form-row triple-row">
          <el-form-item :label="$t('edit.cover.area')">
            <el-cascader
              placeholder="请选择地区"
              style="width: 100%"
              v-model="form.region"
              :options="selectRegion"
              size="large"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item :label="$t('edit.cover.gameLanguage')">
            <el-select
              v-model="form.gameLanguage"
              size="large"
              style="width: 100%"
            >
              <el-option label="繁体中文" value="繁体中文" />
              <el-option label="简体中文" value="简体中文" />
              <el-option label="English" value="English" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('edit.cover.gameCategory')">
            <el-select
              v-model="form.gameClass"
              size="large"
              style="width: 100%"
            >
              <el-option label="单人角色剧本" value="单人角色剧本" />
              <el-option label="多人角色剧本" value="多人角色剧本" />
              <el-option label="亲子互动" value="亲子互动" />
            </el-select>
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item label="游戏分类" class="flex-1">
            <el-select
              v-model="form.gameCategory"
              size="large"
              style="width: 100%"
            >
              <el-option label="博物馆" value="博物馆" />
              <el-option label="城市探索" value="城市探索" />
              <el-option label="线上解密" value="线上解密" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('edit.cover.tag')" class="flex-1">
            <el-select
              v-model="form.tips"
              multiple
              filterable
              allow-create
              multiple-limit="5"
              default-first-option
              placeholder="请选择或输入自定义标签"
              size="large"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item :label="$t('edit.cover.difficulty')" class="flex-1">
            <div class="rate-wrapper">
              <el-rate v-model="form.difficulty" size="large" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('edit.cover.playTime')" class="flex-1">
            <el-input-number
              v-model="form.playTime"
              :min="10"
              :max="120"
              :step="10"
              size="large"
              style="width: 100%"
            />
          </el-form-item>
        </div>

        <el-divider />

        <div class="media-setting-section">
          <span class="media-title">多媒体资源配置</span>

          <div class="media-item-box">
            <div class="media-item-info">
              <span class="label-text">{{ $t("edit.cover.gameCover") }}</span>
              <p class="desc-text">
                游戏在列表展示时的封面图。推荐比例 4:3，支持 JPG/PNG 格式 (5MB
                内)
              </p>
            </div>
            <div class="upload-area-wrapper">
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.gameCover"
                  v-if="form.gameCover"
                  class="avatar"
                  alt="游戏封面"
                  fit="cover"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
              <el-button
                v-if="allowUpload"
                type="danger"
                plain
                @click="clearImage"
                class="clear-main-btn"
              >
                {{ $t("settings.clearImg") }}
              </el-button>
            </div>
          </div>

          <div class="media-item-box column-layout">
            <div class="media-item-info">
              <span class="label-text">{{ $t("edit.cover.slideshow") }}</span>
              <p class="desc-text">
                App 详情页的画廊。最多上传 5 张，可拖动卡片重新排序
              </p>
            </div>

            <div class="slideshow-container">
              <VueDraggable
                ref="el"
                v-model="fileList2"
                class="slideshow-draggable"
              >
                <div
                  v-for="(item, index) in fileList2"
                  :key="item.uid || index"
                  class="slideshow-card"
                >
                  <el-image
                    :src="item.url"
                    fit="cover"
                    class="slideshow-image"
                  />
                  <div class="slideshow-mask" @click="clearImage2(index)">
                    <el-icon class="trash-icon"><DeleteFilled /></el-icon>
                  </div>
                </div>
              </VueDraggable>

              <el-upload
                v-if="fileList2.length < 5"
                :file-list="fileList2"
                :action="UpdateApi"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload2"
                :show-file-list="false"
                list-type="picture-card"
                class="slideshow-uploader"
              >
                <el-icon><Plus /></el-icon>
              </el-upload>
            </div>
          </div>
        </div>

        <el-divider />

        <el-form-item :label="$t('edit.cover.gameDescription')">
          <el-input
            v-model="form.gameDesc"
            type="textarea"
            placeholder="请详细描述游戏的故事背景与核心体验..."
            size="large"
            rows="6"
            show-word-limit
            maxlength="400"
          />
        </el-form-item>

        <el-form-item :label="$t('edit.cover.research_characteristics')">
          <el-input
            v-model="form.features"
            type="textarea"
            placeholder="描述其独有的调研或教育探索特性..."
            size="large"
            rows="6"
            show-word-limit
            maxlength="400"
          />
        </el-form-item>
      </el-form>
      <div class="zhanwei4"></div>
    </div>

    <div class="coverSetting_right">
      <h2 class="mock-title">{{ $t("edit.cover.titleApp") }}</h2>
      <div class="animate__animated animate__fadeIn app-mockup">
        <div class="phone-shell">
          <div class="phone-screen">
            <div class="app_icon">
              <span class="back-circle">
                <el-icon size="16" color="#ffffff"><ArrowLeft /></el-icon>
              </span>
              <span class="more-circle">
                <el-icon size="16" color="#ffffff"><More /></el-icon>
              </span>
            </div>

            <div class="app_cover">
              <el-image
                style="width: 100%; height: 100%"
                :src="
                  form.gameCover == ''
                    ? 'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                    : form.gameCover
                "
                fit="cover"
              />
            </div>

            <div class="author_info">
              <h4 class="mock-game-title">
                {{ form.gameTitle == "" ? "游戏标题" : form.gameTitle }}
              </h4>
              <p class="mock-author">By {{ form.author || "游戏创作者" }}</p>
            </div>

            <div class="about">
              <h5 class="section-sub-title">{{ $t("edit.cover.app1") }}</h5>
              <div class="spec-list">
                <div class="spec-item">
                  <el-icon class="spec-icon"><QuestionFilled /></el-icon>
                  <span class="spec-label">{{ $t("edit.cover.app2") }}：</span>
                  <el-rate v-model="form.difficulty" disabled size="small" />
                </div>
                <div class="spec-item">
                  <el-icon class="spec-icon"><AlarmClock /></el-icon>
                  <span class="spec-label">{{ $t("edit.cover.app3") }}：</span>
                  <span class="spec-val">{{ form.playTime }} 分钟</span>
                </div>
                <div class="spec-item">
                  <el-icon class="spec-icon"><Location /></el-icon>
                  <span class="spec-label">{{ $t("edit.cover.app4") }}：</span>
                  <span class="spec-val">{{
                    form.placeName || "起点地点"
                  }}</span>
                </div>
              </div>
            </div>

            <div class="introduce">
              <h5 class="section-sub-title">{{ $t("edit.cover.app5") }}</h5>
              <p class="introduce-text">
                {{
                  form.gameDesc == ""
                    ? "暂无游戏介绍，请在左侧表单录入。"
                    : form.gameDesc
                }}
              </p>
            </div>

            <div class="mock-bottom-bar">
              <div class="start-btn">开启探索</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
  EditPen,
  DeleteFilled,
} from "@element-plus/icons-vue";
import { UploadProps } from "element-plus";
import { ElNotification } from "element-plus";
import { vDraggable, VueDraggable } from "vue-draggable-plus";

import { area } from "@/components/edit/city";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      form: {
        openHour: "",
        belongId: "",
        createTime: "",
        beginPoint: "",
        endPoint: "",
        walk: "",
        estimateTime: "",
        along: "",
        multiplayer: "",
        playerAge: "",
        difficulty: 3,
        region: "",
        gameClass: "",
        gameCover: "",
        gameDesc: "",
        features: "",
        gameLanguage: "",
        gameLevelId: "",
        gameTitle: "",
        author: "",
        id: "",
        playTime: 1,
        status: 0,
        updateTime: null,
        startTime: "",
        experienceTime: "",
        begin: "",
        transportation: "",
        merchantAddress: "",
        gameCategory: "",
        placeName: "",
        log: "",
        lat: "",
        tips: [],
        carousel: [],
      },
      fileList: [],
      fileList2: [],
      dialogImageUrl: "",
      dialogVisible: false,
      selectRegion: area,
      options: [
        { value: "庙宇", label: "庙宇" },
        { value: "澳门", label: "澳门" },
        { value: "广州", label: "广州" },
        { value: "佛山", label: "佛山" },
        { value: "深圳", label: "深圳" },
        { value: "博物馆", label: "博物馆" },
        { value: "非遗", label: "非遗" },
        { value: "环保", label: "环保" },
        { value: "动物园", label: "动物园" },
        { value: "植物园", label: "植物园" },
        { value: "科学馆", label: "科学馆" },
        { value: "历史街区", label: "历史街区" },
        { value: "红色主题", label: "红色主题" },
      ],
    };
  },
  components: {
    DeleteFilled,
    EditPen,
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
    VueDraggable,
  },
  directives: {
    draggable: vDraggable,
  },
  computed: {
    allowUpload() {
      return this.form.gameCover !== "" && this.form.gameCover !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {
    if (this.$route.params.id != 0) {
      const game = this.$store.state.game.games.find((item: any) => {
        return item.id == this.$route.params.id;
      });

      if (game != undefined && game.gameLevelId != "") {
        this.form = game;

        if (this.form.region && this.form.region !== "") {
          if (typeof this.form.region === "string") {
            this.form.region = this.form.region.split(",");
          }
        } else {
          this.form.region = [];
        }

        if (this.form.carousel != null && this.form.carousel !== "") {
          this.fileList2 = this.form.carousel
            .split(",")
            .map((url: string, index: number) => {
              return { url, uid: index, name: `file-${index}` };
            });
        }

        this.$forceUpdate();
        this.fetchGameList(game.gameLevelId);
      }
    }
  },
  methods: {
    handleSave() {
      const { updateTime, ...formWithoutUpdateTime } = this.form;
      // 避免修改原始对象
      const payload = { ...formWithoutUpdateTime };
      payload.tips = JSON.stringify(payload.tips);
      payload.carousel = this.fileList2.map((item) => item.url).join(",");
      payload.region = this.form.region.join(",");

      this.$store
        .dispatch("game/updateGame", { gameBean: payload })
        .then(() => {
          this.$message.success("保存成功");
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    },
    fetchGameList(gameLevelId: string) {
      this.$store
        .dispatch("game/getGameLevelList", { gameLevelId: gameLevelId })
        .then((res: any) => {})
        .catch((err: any) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.gameCover = reader.result as string;
      };

      return true;
    },
    beforeAvatarUpload2(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      return this.fileList2.length < 5;
    },
    handleAvatarSuccess(response: any) {
      this.form.gameCover = response.data.returnFileUrl;
    },
    handleAvatarSuccess2(response: any) {
      if (response.code == 200) {
        this.fileList2.push({
          url: response.data.returnFileUrl,
          uid: Date.now(),
          name: `img-${Date.now()}`,
          status: "finished",
        });
      }
    },
    clearImage2(index: number) {
      this.fileList2.splice(index, 1);
    },
    clearImage() {
      this.form.gameCover = "";
      this.fileList = [];
    },
  },
});
</script>

<style lang="less" scoped>
/* 顶层头部与保存栏 */
.header-action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 20px;

  .page-title {
    font-size: 24px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
  }

  .save-top-btn {
    background-color: #2c3e50;
    border-color: #2c3e50;
    font-weight: bold;
    padding: 12px 28px;

    &:hover {
      background-color: #1a252f;
      border-color: #1a252f;
    }
  }
}

/* 主容器 */
.coverSetting {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  gap: 40px;
  box-sizing: border-box;

  /* 左侧干净表单样式 */
  &_left {
    flex: 1;
    background: #ffffff;
    padding: 36px;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;

    .clean-form {
      :deep(.el-form-item) {
        margin-bottom: 22px;

        .el-form-item__label {
          font-weight: 600;
          color: #2c3e50;
          padding-bottom: 6px;
        }
      }

      /* 通行多列排版控制 */
      .form-row {
        display: flex;
        gap: 16px;

        .el-form-item {
          flex: 1;
          margin-bottom: 22px;
        }

        &.geolocation-row {
          .flex-2 {
            flex: 2;
          }
          .flex-1 {
            flex: 1;
          }
        }

        .flex-2 {
          flex: 2;
        }
        .flex-1 {
          flex: 1;
        }
      }
    }

    /* 评分 */
    .rate-wrapper {
      height: 40px;
      display: flex;
      align-items: center;
    }

    /* 模块分割线 */
    .el-divider {
      margin: 32px 0;
    }

    /* 资源上传大模块 */
    .media-setting-section {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .media-title {
        font-size: 16px;
        font-weight: bold;
        color: #2c3e50;
        margin-bottom: 8px;
      }

      .media-item-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fdfdfd;
        border: 1px solid #f2f2f2;
        padding: 20px;
        border-radius: 8px;
        gap: 20px;

        &.column-layout {
          flex-direction: column;
          align-items: flex-start;
        }

        .media-item-info {
          flex: 1;
          .label-text {
            display: block;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 4px;
          }
          .desc-text {
            font-size: 13px;
            color: #909399;
            margin: 0;
            line-height: 1.5;
          }
        }

        .upload-area-wrapper {
          display: flex;
          align-items: flex-end;
          gap: 12px;
        }
      }
    }

    /* 封面图长宽配置 */
    .avatar-uploader {
      border: 1px dashed #dcdfe6;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 160px;
      height: 120px; /* 4:3 黄金比例 */
      transition: all 0.3s;
      background: #fafafa;

      &:hover {
        border-color: #409eff;
        background: #f5f7fa;
      }

      .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .avatar-uploader-icon {
        font-size: 24px;
        color: #8c939d;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    /* 轮播图模块 */
    .slideshow-container {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 12px;
      width: 100%;

      .slideshow-draggable {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
      }

      .slideshow-card {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        border: 1px solid #ebeef5;
        cursor: grab;

        &:active {
          cursor: grabbing;
        }

        .slideshow-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* 磨砂半透明删除蒙层 */
        .slideshow-mask {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.4);
          backdrop-filter: blur(2px);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.2s ease;
          cursor: pointer;

          .trash-icon {
            color: #ffffff;
            font-size: 20px;
          }
        }

        &:hover .slideshow-mask {
          opacity: 1;
        }
      }

      /* 轮播图上传卡片尺寸对齐 */
      :deep(.slideshow-uploader .el-upload--picture-card) {
        width: 120px;
        height: 120px;
        background-color: #fafafa;
        border: 1px dashed #dcdfe6;
        border-radius: 8px;

        &:hover {
          border-color: #409eff;
          background-color: #f5f7fa;
        }
      }
    }
  }

  /* 右侧高拟真 APP 模拟器 */
  &_right {
    width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;

    .mock-title {
      font-size: 16px;
      font-weight: 600;
      color: #57606f;
      margin-bottom: 24px;
      align-self: center;
    }

    .phone-mockup {
      width: 300px;
      height: 620px;
      background: #000000;
      border-radius: 40px;
      padding: 12px;
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.15);
      box-sizing: border-box;

      .phone-screen {
        width: 100%;
        height: 100%;
        background: #f8f9fa;
        border-radius: 30px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        position: relative;

        /* 顶部毛玻璃导航小球 */
        .app_icon {
          position: absolute;
          top: 16px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          padding: 0 16px;
          z-index: 10;

          .back-circle,
          .more-circle {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.35);
            backdrop-filter: blur(4px);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
        }

        /* 顶图 */
        .app_cover {
          width: 100%;
          height: 38%;
          background-color: #e3e3e3;
          overflow: hidden;
        }

        /* 标题信息卡片 */
        .author_info {
          background: #ffffff;
          padding: 16px;
          margin-top: -20px;
          border-radius: 16px 16px 0 0;
          position: relative;
          z-index: 2;
          border-bottom: 1px solid #f1f2f6;

          .mock-game-title {
            margin: 0 0 6px 0;
            font-size: 16px;
            font-weight: bold;
            color: #2f3542;
            line-height: 1.4;
          }

          .mock-author {
            margin: 0;
            font-size: 12px;
            color: #747d8c;
          }
        }

        /* 子属性面板样式 */
        .about {
          background: #ffffff;
          padding: 14px 16px;
          margin-top: 8px;

          .section-sub-title {
            margin: 0 0 10px 0;
            font-size: 13px;
            font-weight: 600;
            color: #2f3542;
          }

          .spec-list {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .spec-item {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #57606f;

              .spec-icon {
                margin-right: 8px;
                color: #a4b0be;
                font-size: 14px;
              }

              .spec-label {
                color: #747d8c;
              }

              .spec-val {
                color: #2f3542;
                font-weight: 500;
              }

              :deep(.el-rate) {
                height: auto;
              }
            }
          }
        }

        /* 介绍描述区 */
        .introduce {
          background: #ffffff;
          padding: 14px 16px;
          margin-top: 8px;
          flex: 1;
          overflow-y: auto;
          box-sizing: border-box;

          .section-sub-title {
            margin: 0 0 8px 0;
            font-size: 13px;
            font-weight: 600;
            color: #2f3542;
          }

          .introduce-text {
            margin: 0;
            font-size: 12px;
            color: #57606f;
            line-height: 1.6;
            white-space: pre-wrap;
          }
        }

        /* 底部伪探索操作 */
        .mock-bottom-bar {
          background: #ffffff;
          padding: 12px 16px 20px;
          box-sizing: border-box;
          border-top: 1px solid #f1f2f6;

          .start-btn {
            width: 100%;
            height: 38px;
            background: #02a7e5;
            color: #ffffff;
            font-weight: 600;
            font-size: 13px;
            border-radius: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 4px 10px rgba(2, 167, 229, 0.3);
            cursor: pointer;
          }
        }
      }
    }
  }
}

/* 屏幕宽度缩小自适应适配 */
@media screen and (max-width: 1100px) {
  .coverSetting {
    flex-direction: column;
    align-items: center;

    &_left {
      width: 100%;
    }

    &_right {
      display: none; /* 移动端或者小窗口宽度下隐藏预览区，留存表单编辑空间 */
    }
  }
}
</style>
